import React from 'react';
import { LTBox, LTButton, LTText } from '@lambdatestincprivate/lt-components';
import AccessibilityIllustration from '../../assets/accessibility/AccessibilityIllustration';

const getBlockedReasonContent = (blockedReason) => {
  if (blockedReason === 'ACCESSIBILITY_SCANS_EXHAUSTED') {
    return {
      title: 'Accessibility Scans Exhausted',
      message:
        'Your accessibility scans have been exhausted. Please upgrade your plan to continue viewing accessibility reports.',
      showCapability: false,
      showContactSupport: false,
    };
  }
  if (blockedReason === 'ACCESSIBILITY_PLAN_NOT_AVAILABLE') {
    return {
      title: 'Accessibility Plan Not Available',
      message:
        'Accessibility is not included in your current plan. Please upgrade your plan to access accessibility reports.',
      showCapability: false,
      showContactSupport: false,
    };
  }
  // Default for unknown blocked reasons
  if (blockedReason) {
    return {
      title: 'Accessibility Report Unavailable',
      message: blockedReason,
      showCapability: false,
      showContactSupport: false,
    };
  }
  // Default when no blocked reason (original behavior)
  return {
    title: 'Accessibility is not enabled for your account',
    message:
      'To enable, please contact our support team and use the below mentioned flag in your test capabilities configuration to get Accessibility Automation.',
    showCapability: true,
    showContactSupport: true,
  };
};

const AccessibilityPlanError = ({ blockedReason }) => {
  const { title, message, showCapability, showContactSupport } =
    getBlockedReasonContent(blockedReason);

  // Center the content when showing blocked reason message
  const isBlockedReasonView = !!blockedReason;

  return (
    <LTBox
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems={isBlockedReasonView ? 'center' : undefined}
      height={isBlockedReasonView ? '100%' : 'fit-content'}
    >
      <LTBox
        flexGrow="1"
        padding="32px"
        maxWidth="512px"
        alignItems="center"
        height={isBlockedReasonView ? 'auto' : '100%'}
      >
        <LTText fontSize={LTText.FontSize.FONT_20} fontWeight="600" margin="0">
          {title}
        </LTText>
        <LTText
          fontSize={LTText.FontSize.FONT_14}
          fontWeight="400"
          margin="0"
          color="fg.muted"
          marginTop="4px"
        >
          {message}
        </LTText>
        {showCapability && (
          <LTText
            fontSize={LTText.FontSize.FONT_14}
            fontWeight="500"
            margin="0"
            marginBottom="32px"
          >
            {`capability = { accessibility: true }`}
          </LTText>
        )}

        {showContactSupport && (
          <>
            <LTButton
              ariaLabel="Contact Support to enable Accessibility"
              data-testid="a11y-contact-support-btn"
              label="Contact Support"
              onClick={() => {
                window.location = 'mailto: support@lambdatest.com';
              }}
              size={LTButton.Size.MEDIUM}
              variant={LTButton.Variant.PRIMARY}
            />
            <LTText
              fontSize={LTText.FontSize.FONT_12}
              fontWeight="400"
              margin="0"
              marginTop="8px"
              color="fg.muted"
              fontStyle="italic"
            >
              Email us at support@lambdatest.com
            </LTText>
          </>
        )}
      </LTBox>
      <AccessibilityIllustration />
    </LTBox>
  );
};

export default AccessibilityPlanError;
